import React, { useEffect } from 'react';
import styled from 'styled-components'

const HealthCheck = ({ redirectionType }) => {

  useEffect(() => {
  }, []);

  return (
    <Container>
      Health Check
    </Container>
  )
};

export default HealthCheck;

const Container = styled.div`
        max-width: 1411px;
        padding: 15px 98px;
        margin: 0 auto;
        @media (max-width:1250px) {
            padding: 15px;
        }
`